import { C } from "../../shared/theme";
import { DragHandle } from "../../shared/Sortable";
import { goalCardBg } from "../../shared/goalColors";
import { formatDeadlineDate } from "../../shared/deadlines";
import { AddItemButton } from "../../shared/AddItemButton";

// One goal as the Goals page draws it, and Radar's goal groups too (Craig, 25 Oct 2026: "change the display of goals
// (and their related tasks) to look the way they do on the Goals page"): a bar in the goal's colour and, when open,
// its unfinished tasks (`openTasks`, each drawn by `row(task)`) and "+ Add a task". `words` says how many tasks are
// left. onOpenGoal opens the goal, onToggle folds it, onAddTask starts a task for it.
export function GoalBlock({ goal, words, openTasks, open, onToggle, onOpenGoal, onAddTask, row, dated = false, drag = null }) {
  return (
    <div style={{ marginBottom: open ? 16 : 6 }}>
      <GoalBar goal={goal} words={words} open={open} onToggle={onToggle} onOpenGoal={onOpenGoal} dated={dated} drag={drag} />
      {open && (
        <div>
          {openTasks.map(row)}
          <AddItemButton onClick={onAddTask} />
        </div>
      )}
    </div>
  );
}

// The bar: the goal's name opens the goal, the rest of the bar shows or hides its tasks, and ⠿ (when `drag` is given)
// moves it. `dated` adds the goal's deadline (the Calendar view).
function GoalBar({ goal, words, open, onToggle, onOpenGoal, dated, drag }) {
  return (
    <div style={{ display: "flex", alignItems: "stretch", minHeight: 48, background: goalCardBg(goal.color), borderRadius: C.rsm, padding: drag ? "0 0 0 14px" : "0 14px", marginBottom: open ? 4 : 0, boxShadow: drag?.isDragging ? C.shadowMd : C.shadow }}>
      <button onClick={onOpenGoal} aria-label={`Open ${goal.title}`}
        style={{ flex: "0 1 auto", minWidth: 0, padding: "10px 8px 10px 0", background: "none", border: "none", textAlign: "left", fontSize: 16, fontWeight: 700, lineHeight: 1.3, color: C.onGoal, cursor: "pointer", fontFamily: "inherit" }}>
        {goal.title}
      </button>
      <button onClick={onToggle} aria-expanded={open} aria-label={`${goal.title}: ${words}`}
        style={{ flex: "1 0 auto", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 6, padding: 0, background: "none", border: "none", fontSize: 13, color: C.onGoal, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
        {dated && goal.deadline && <span>{formatDeadlineDate(goal.deadline)}</span>}
        <span>{words}</span>
        <span aria-hidden="true" style={{ fontSize: 11 }}>{open ? "▲" : "▼"}</span>
      </button>
      {drag && <DragHandle label={goal.title} color={C.onGoalDim} {...drag} />}
    </div>
  );
}
